import React from 'react';
import { StyledDetailTextWrapper, StyledDetailTextLabel, StyledDetailText } from './DeviceDetailsText.style';
import { StyledAsterisk } from '../../commonComponents/Textbox/Textbox.style'

export interface IDeviceDetailsText {
  label: string,
  required?: boolean,
  data?: string,
}


export default function DeviceDetailsText(props: IDeviceDetailsText) {
  const { label, required, data} = props;

  return (
    <StyledDetailTextWrapper>
      <StyledDetailTextLabel>{label}
      {
        required &&
        <StyledAsterisk>*</StyledAsterisk>
      }
      </StyledDetailTextLabel>
      <StyledDetailText>{data}</StyledDetailText>
    </StyledDetailTextWrapper>
  )
}

export const defaultProps = {
  label: 'Test',
  required: true,
  data: 'empty',
}
